// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d561e9851e382f3c9508","655":"5f89de9309159449b6d8"}[chunkId] + ".js";
};